import { render, staticRenderFns } from "./TypeIndexPage.vue?vue&type=template&id=3267cebb&"
import script from "./TypeIndexPage.vue?vue&type=script&lang=js&"
export * from "./TypeIndexPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports